import { BooleanStateStorage } from "../BooleanStateStorage";
import { AccordionKey } from "../accordion-keys/AccordionKeys.types";
import {
  AccordionEvent,
  AccordionStateMap,
  CHANNEL_NAME,
  STORAGE_KEY,
  isAccordionChannelMessage,
  isAccordionStateMap,
} from "./accordionStorage.types";

class AccordionStorage extends BooleanStateStorage<AccordionKey> {
  protected readonly storageKey = STORAGE_KEY;

  private channel: BroadcastChannel | null;

  constructor() {
    super();
    this.channel =
      typeof window !== "undefined" && "BroadcastChannel" in window ? new BroadcastChannel(CHANNEL_NAME) : null;

    if (this.channel) {
      this.channel.addEventListener("message", this.handleMessage);
    }
  }

  clear(): void {
    this.saveState(null);
  }

  protected isValidState(value: unknown): value is AccordionStateMap {
    return isAccordionStateMap(value);
  }

  protected onStateSaved(state: AccordionStateMap): void {
    this.channel?.postMessage({ type: AccordionEvent.UPDATED, payload: state });
  }

  protected onStateCleared(): void {
    this.channel?.postMessage({ type: AccordionEvent.CLEARED });
  }

  private handleMessage = (event: MessageEvent) => {
    const data: unknown = event.data;

    if (!isAccordionChannelMessage(data)) {
      return;
    }

    if (data.type === AccordionEvent.UPDATED) {
      //we do not want to re-render on changes
      this.cache = data.payload;
    }

    if (data.type === AccordionEvent.CLEARED) {
      this.cache = null;
    }
  };
}

export const accordionStorage = new AccordionStorage();
